// extracted by mini-css-extract-plugin
export default {"mobile":"mBQM7","root":"TvgfR","onImage":"+QXzT"};